import React from 'react';
import DialerButton from './DialerButton';

interface KeypadProps {
  onInput: (digit: string) => void;
}

const Keypad: React.FC<KeypadProps> = ({ onInput }) => {
  // T9 keypad mapping with letters
  const keypadMapping = [
    { number: '1', letters: '' },
    { number: '2', letters: 'ABC' },
    { number: '3', letters: 'DEF' },
    { number: '4', letters: 'GHI' },
    { number: '5', letters: 'JKL' },
    { number: '6', letters: 'MNO' },
    { number: '7', letters: 'PQRS' },
    { number: '8', letters: 'TUV' },
    { number: '9', letters: 'WXYZ' },
    { number: '*', letters: '' },
    { number: '0', letters: '+', longPressValue: '+' },
    { number: '#', letters: '' },
  ];

  return (
    <>
      {keypadMapping.map((key) => (
        <DialerButton
          key={key.number}
          number={key.number}
          letters={key.letters}
          longPressValue={'longPressValue' in key ? key.longPressValue : undefined}
          onClick={onInput}
        />
      ))}
    </>
  );
};

export default Keypad;
